import { collections } from "@/mocks/chiguaHome";

export default function CollectionBoard() {
  return (
    <section id="collection" className="scroll-mt-20 bg-[#fbf7f0]">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-orange-700">
              <i className="ri-archive-stack-line"></i> Collections
            </span>
            <h2 className="mt-2 text-2xl font-extrabold tracking-tight text-stone-900 md:text-3xl">
              专题合集 <span className="text-orange-600">·</span> 一个瓜吃到透
            </h2>
            <p className="mt-2 max-w-xl text-sm text-stone-500">
              把散落在各处的讨论整理成带索引的专题，点开即看该话题的时间线、图集与核心帖。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {collections.map((c) => (
            <article key={c.title} className="group flex flex-col overflow-hidden rounded-xl border border-stone-200 bg-white transition-colors hover:border-orange-300">
              <div className="relative h-44 overflow-hidden md:h-48">
                <img
                  src={c.cover}
                  alt={`${c.title}专题合集`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-black/55 px-2.5 py-1 text-[11px] font-semibold text-white backdrop-blur-sm">
                  <i className="ri-price-tag-3-line"></i> {c.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <div className="flex items-center justify-between">
                  <h3 className="text-base font-bold text-stone-900 md:text-lg">{c.title}</h3>
                  <span className="shrink-0 text-[11px] text-stone-400">{c.update}</span>
                </div>
                <p className="mt-2 flex-1 text-xs leading-relaxed text-stone-600 md:text-sm">{c.summary}</p>
                <div className="mt-4 flex items-center justify-between">
                  <span className="inline-flex items-center gap-1 rounded-full bg-orange-50 px-2.5 py-1 text-[11px] font-semibold text-orange-700">
                    <i className="ri-file-list-3-line"></i> {c.posts}
                  </span>
                  <a href="#collection" className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-orange-700 transition-colors hover:text-orange-800">
                    进入专题 <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}